export function getClientInfo() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const screenResolution =
    window.screen && window.screen.width
      ? `${window.screen.width}x${window.screen.height}`
      : "";

  return { timezone, screenResolution };
}
